module.exports = __webpack_public_path__ + "media/corporate-image/hyakkaten_banner-e82b826ee0b44d56f439b84582047329.jpg";